// extracted by mini-css-extract-plugin
export var icon = "_5j-3";
export var subtitle = "_5j-2";
export var title = "_5j-1";
export var value = "_5j-0";